function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_368",
  "data-name": "Trazado 368",
  d: "M2691.306,812.54H2250.048a12.221,12.221,0,0,1-12.186-12.186h0a12.222,12.222,0,0,1,12.186-12.186h441.258a12.221,12.221,0,0,1,12.185,12.186h0A12.221,12.221,0,0,1,2691.306,812.54Z",
  fill: "#9ab748"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_307",
  "data-name": "Grupo 307"
}, /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_98",
  "data-name": "L\\xEDnea 98",
  y1: 203.172,
  transform: "translate(2287.212 593.603)",
  fill: "none",
  stroke: "#564f4c",
  strokeMiterlimit: 10,
  strokeWidth: 6.966
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_369",
  "data-name": "Trazado 369",
  d: "M2284.31,713.765s-68.5,4.644-63.854-87.655",
  fill: "none",
  stroke: "#564f4c",
  strokeMiterlimit: 10,
  strokeWidth: 6.966
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_370",
  "data-name": "Trazado 370",
  d: "M2235.549,691.125s23.219-4.644,26.122-59.21",
  fill: "none",
  stroke: "#564f4c",
  strokeMiterlimit: 10,
  strokeWidth: 6.966
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_371",
  "data-name": "Trazado 371",
  d: "M2288.954,684.74s47.02,15.673,47.02-76.044",
  fill: "none",
  stroke: "#564f4c",
  strokeMiterlimit: 10,
  strokeWidth: 6.966
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_372",
  "data-name": "Trazado 372",
  d: "M2321.071,362.166a17.983,17.983,0,0,1,23.795,23.308,63.347,63.347,0,0,1,68.548,74.826c8.568-1.206,17.09,3.872,22.195,10.858s7.383,15.607,9.1,24.089c3.371,16.7,4.875,34.457-1.008,50.451s-20.785,29.648-37.825,29.477c10.358,13.04,10.489,33.185.3,46.358s-29.717,18.113-44.942,11.368c-20.7,20.438-56.259,23.5-80.141,6.891a47.007,47.007,0,0,1-81.423-13.421,31.45,31.45,0,0,1-41.405-43.411c-10.143,2.694-21.744,2.2-30.135-4.108s-11.888-19.415-5.536-27.769c-18.861-8.362-32.454-28.421-31.4-49.026s17.912-39.807,38.444-41.832c-4.321-5.777-2.239-14.562,2.936-19.589s12.559-7.029,19.705-8.022c-6.734-19.207,1.178-42.518,18.211-53.658s41.562-9.043,56.458,4.825a25.419,25.419,0,0,1,36.528-30.485c-.451-9.3-.768-19.164,3.758-27.306s15.787-13.273,23.485-8.027c7.806,5.32,7.256,16.8,5.84,26.139,4.421-7.163,15.287-9.269,22.063-4.275S2326.6,355.822,2321.071,362.166Z",
  fill: "#9ab748"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_374",
  "data-name": "Trazado 374",
  d: "M2663.747,519.313v273.2L2317.5,789.671l-4.743-272.256,165.061-159.369Z",
  fill: "#f2b84b"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_377",
  "data-name": "Trazado 377",
  d: "M2485.405,519.313l-90.594-78.262-86.8,78.262V787.774h177.393Z",
  fill: "#fcca7a"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_379",
  "data-name": "Trazado 379",
  d: "M2680.194,547.664,2477.989,367.1,2290.8,547.494l-9.216-9.564,196.058-188.94,211.4,188.769Z",
  fill: "#4f413f"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1014",
  "data-name": "Rect\\xE1ngulo 1014",
  width: 13.281,
  height: 150.111,
  transform: "matrix(0.684, -0.73, 0.73, 0.684, 2392.644, 444.949)",
  fill: "#4f413f"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1015",
  "data-name": "Rect\\xE1ngulo 1015",
  width: 360.004,
  height: 48.854,
  transform: "translate(2305.641 743.663)",
  fill: "#a37c43"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1017",
  "data-name": "Rect\\xE1ngulo 1017",
  width: 50.593,
  height: 75.89,
  transform: "translate(2407.736 633.78)",
  fill: "#6f95a5"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_380",
  "data-name": "Trazado 380",
  d: "M2459.088,635.572V633.78h-10.5l-18.366,16.45a84.76,84.76,0,0,0-10.65,10.75,3.872,3.872,0,0,0-1.047,2.3c.034,2.6,4.215,2.706,5.671,4.865,1.385,2.054-.305,4.734-1.922,6.61l-13.779,15.99V709.67h18.574c8.241-10.757,16.116-21.8,22.272-33.843a8.694,8.694,0,0,0,1.193-3.586c.119-3.724-3.977-5.872-6.9-8.188a4.636,4.636,0,0,1-1.964-2.792,5.268,5.268,0,0,1,1.176-3.391A233.6,233.6,0,0,1,2459.088,635.572Z",
  fill: "#fff",
  opacity: 0.35
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_382",
  "data-name": "Trazado 382",
  d: "M2460.227,711.567H2405.84V631.883h54.387Zm-50.593-3.794h46.8v-72.1h-46.8Z",
  fill: "#f2f2f2"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1018",
  "data-name": "Rect\\xE1ngulo 1018",
  width: 3.795,
  height: 74.941,
  transform: "translate(2431.136 634.334)",
  fill: "#f2f2f2"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1019",
  "data-name": "Rect\\xE1ngulo 1019",
  width: 50.593,
  height: 75.89,
  transform: "translate(2366.827 525.447)",
  fill: "#6f95a5"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_383",
  "data-name": "Trazado 383",
  d: "M2418.178,527.238v-1.791h-10.5l-18.366,16.45a84.683,84.683,0,0,0-10.65,10.75,3.869,3.869,0,0,0-1.047,2.3c.034,2.6,4.215,2.7,5.671,4.865,1.385,2.053-.3,4.733-1.922,6.61l-13.779,15.99v18.925h18.574c8.241-10.757,16.116-21.8,22.272-33.843a8.7,8.7,0,0,0,1.193-3.586c.119-3.724-3.977-5.873-6.9-8.188a4.637,4.637,0,0,1-1.964-2.793,5.274,5.274,0,0,1,1.176-3.391A234.062,234.062,0,0,1,2418.178,527.238Z",
  fill: "#fff",
  opacity: 0.35
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_385",
  "data-name": "Trazado 385",
  d: "M2419.318,603.234H2364.93V523.549h54.388Zm-50.593-3.795h46.8v-72.1h-46.8Z",
  fill: "#f2f2f2"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1020",
  "data-name": "Rect\\xE1ngulo 1020",
  width: 3.795,
  height: 74.941,
  transform: "translate(2390.227 526)",
  fill: "#f2f2f2"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1021",
  "data-name": "Rect\\xE1ngulo 1021",
  width: 50.593,
  height: 75.89,
  transform: "translate(2545.615 525.447)",
  fill: "#6f95a5"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_386",
  "data-name": "Trazado 386",
  d: "M2596.966,527.238v-1.791h-10.5L2568.1,541.9a84.685,84.685,0,0,0-10.65,10.75,3.87,3.87,0,0,0-1.047,2.3c.034,2.6,4.215,2.7,5.671,4.865,1.384,2.053-.3,4.733-1.922,6.61l-13.779,15.99v18.925h18.574c8.241-10.757,16.116-21.8,22.272-33.843a8.7,8.7,0,0,0,1.193-3.586c.119-3.724-3.977-5.873-6.9-8.188a4.638,4.638,0,0,1-1.963-2.793,5.277,5.277,0,0,1,1.175-3.391A234.242,234.242,0,0,1,2596.966,527.238Z",
  fill: "#fff",
  opacity: 0.35
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_388",
  "data-name": "Trazado 388",
  d: "M2598.106,603.234h-54.388V523.549h54.388Zm-50.593-3.795h46.8v-72.1h-46.8Z",
  fill: "#f2f2f2"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1022",
  "data-name": "Rect\\xE1ngulo 1022",
  width: 3.795,
  height: 74.941,
  transform: "translate(2569.015 526)",
  fill: "#f2f2f2"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1023",
  "data-name": "Rect\\xE1ngulo 1023",
  width: 50.593,
  height: 75.89,
  transform: "translate(2330.747 633.78)",
  fill: "#6f95a5"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_389",
  "data-name": "Trazado 389",
  d: "M2382.1,635.572V633.78h-10.5l-18.366,16.45a84.7,84.7,0,0,0-10.65,10.75,3.872,3.872,0,0,0-1.047,2.3c.034,2.6,4.215,2.706,5.671,4.865,1.385,2.054-.305,4.734-1.922,6.61l-13.779,15.99V709.67h18.574c8.241-10.757,16.116-21.8,22.272-33.843a8.694,8.694,0,0,0,1.193-3.586c.119-3.724-3.977-5.872-6.9-8.188a4.636,4.636,0,0,1-1.964-2.792,5.268,5.268,0,0,1,1.176-3.391A233.762,233.762,0,0,1,2382.1,635.572Z",
  fill: "#fff",
  opacity: 0.35
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_391",
  "data-name": "Trazado 391",
  d: "M2383.238,711.567H2328.85V631.883h54.388Zm-50.593-3.794h46.8v-72.1h-46.8Z",
  fill: "#f2f2f2"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1024",
  "data-name": "Rect\\xE1ngulo 1024",
  width: 3.795,
  height: 74.941,
  transform: "translate(2354.147 634.334)",
  fill: "#f2f2f2"
});

var _ref26 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_317",
  "data-name": "Grupo 317"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1025",
  "data-name": "Rect\\xE1ngulo 1025",
  width: 71.463,
  height: 139.764,
  transform: "translate(2536.76 632.239)",
  fill: "#4f413f"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_318",
  "data-name": "Grupo 318"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_30",
  "data-name": "Elipse 30",
  cx: 24.98,
  cy: 24.98,
  r: 24.98,
  transform: "translate(2456.63 421.92)",
  fill: "#c4e2ff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_31",
  "data-name": "Elipse 31",
  cx: 21.305,
  cy: 21.305,
  r: 21.305,
  transform: "translate(2451.347 460.595) rotate(-67.805)",
  fill: "#6f95a5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_392",
  "data-name": "Trazado 392",
  d: "M2481.754,422.11a24.981,24.981,0,1,0,24.981,24.98A24.98,24.98,0,0,0,2481.754,422.11Zm-2.49,48.3a21.305,21.305,0,1,1,21.305-21.305A21.3,21.3,0,0,1,2479.264,470.411Z",
  fill: "#497e91"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_393",
  "data-name": "Trazado 393",
  d: "M2481.611,473.779a26.878,26.878,0,1,1,26.877-26.879A26.909,26.909,0,0,1,2481.611,473.779Zm0-49.961a23.083,23.083,0,1,0,23.083,23.082A23.109,23.109,0,0,0,2481.611,423.818Z",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1026",
  "data-name": "Rect\\xE1ngulo 1026",
  width: 3.953,
  height: 50.277,
  transform: "translate(2479.397 421.92)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1027",
  "data-name": "Rect\\xE1ngulo 1027",
  width: 3.953,
  height: 49.566,
  transform: "translate(2507.224 445.873) rotate(90)",
  fill: "#f2f2f2"
}));

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1028",
  "data-name": "Rect\\xE1ngulo 1028",
  width: 130.594,
  height: 10.593,
  transform: "translate(2507.194 782.082)",
  fill: "#665857"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1029",
  "data-name": "Rect\\xE1ngulo 1029",
  width: 114.151,
  height: 10.593,
  transform: "translate(2515.416 771.648)",
  fill: "#3a2b29"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_394",
  "data-name": "Trazado 394",
  d: "M2571.454,643.583h0a15.613,15.613,0,0,0-15.613,15.613v48.893h31.226V659.2A15.613,15.613,0,0,0,2571.454,643.583Z",
  fill: "#6f95a5"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1030",
  "data-name": "Rect\\xE1ngulo 1030",
  width: 3.439,
  height: 67.353,
  transform: "translate(2569.24 642.16)",
  fill: "#4f413f"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1031",
  "data-name": "Rect\\xE1ngulo 1031",
  width: 32.372,
  height: 2.846,
  transform: "translate(2555.129 676.31)",
  fill: "#4f413f"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_396",
  "data-name": "Trazado 396",
  d: "M2549.121,714.177a2.767,2.767,0,1,0-2.766,2.766A2.766,2.766,0,0,0,2549.121,714.177Z",
  fill: "#f2b84b"
});

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_320",
  "data-name": "Grupo 320"
}, /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_99",
  "data-name": "L\\xEDnea 99",
  y1: 28.863,
  transform: "translate(2461.029 769.859)",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_397",
  "data-name": "Trazado 397",
  d: "M2474.36,772.19s-1.528,11.3-13.053,12.478",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_398",
  "data-name": "Trazado 398",
  d: "M2482.969,777.181s-1.666,6.3-15.136,5.254",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_399",
  "data-name": "Trazado 399",
  d: "M2460.751,787.49s-16.975.394-19.475-10.935",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_400",
  "data-name": "Trazado 400",
  d: "M2452.628,775.964s-.833,6.4-4.9,8.078",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_321",
  "data-name": "Grupo 321"
}, /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_100",
  "data-name": "L\\xEDnea 100",
  y1: 28.863,
  transform: "translate(2409.203 769.859)",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_401",
  "data-name": "Trazado 401",
  d: "M2422.534,772.19s-1.528,11.3-13.053,12.478",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_402",
  "data-name": "Trazado 402",
  d: "M2431.143,777.181s-1.666,6.3-15.136,5.254",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_403",
  "data-name": "Trazado 403",
  d: "M2408.925,787.49s-16.975.394-19.475-10.935",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_404",
  "data-name": "Trazado 404",
  d: "M2400.8,775.964s-.833,6.4-4.9,8.078",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_322",
  "data-name": "Grupo 322"
}, /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_101",
  "data-name": "L\\xEDnea 101",
  y1: 28.863,
  transform: "translate(2351.814 769.859)",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_405",
  "data-name": "Trazado 405",
  d: "M2365.145,772.19s-1.528,11.3-13.053,12.478",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_406",
  "data-name": "Trazado 406",
  d: "M2373.754,777.181s-1.666,6.3-15.136,5.254",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_407",
  "data-name": "Trazado 407",
  d: "M2351.536,787.49s-16.975.394-19.475-10.935",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_408",
  "data-name": "Trazado 408",
  d: "M2344.571,771.439s3.319,10.148-6.319,12.829",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_323",
  "data-name": "Grupo 323"
}, /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_102",
  "data-name": "L\\xEDnea 102",
  y1: 28.863,
  transform: "translate(2297.244 769.859)",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_409",
  "data-name": "Trazado 409",
  d: "M2310.574,772.19s-1.527,11.3-13.053,12.478",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_410",
  "data-name": "Trazado 410",
  d: "M2319.184,777.181s-1.667,6.3-15.136,5.254",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_411",
  "data-name": "Trazado 411",
  d: "M2296.966,787.49s-16.976.394-19.475-10.935",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_412",
  "data-name": "Trazado 412",
  d: "M2288.843,775.964s-.834,6.4-4.9,8.078",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 1.621
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_413",
  "data-name": "Trazado 413",
  d: "M2305.22,774.767c-1.347,6.625-12.042,8.465-15.525,2.671-1.509,5.349-10.841,5.414-12.424.087-.025,3.067-4.663,4.316-6.946,2.268s-2.342-5.69-1.258-8.559,3.07-5.3,4.457-8.036a21.3,21.3,0,0,0,.517-17.892c-.914-2.093-2.183-4.08-2.549-6.335a8.282,8.282,0,0,1,15.66-4.874c2.559-5.465,9.521-6.911,15.506-7.68,7.013-.9,15.619-1.114,19.452,4.828a24.361,24.361,0,0,1,40.142.393,11.734,11.734,0,0,1,14.66-5.155c1.862.83,3.591,2.187,5.628,2.26,2.065.074,3.932-1.2,5.969-1.545,2.368-.4,4.742.463,7.045,1.145a48.091,48.091,0,0,0,17.012,1.853,17.181,17.181,0,0,1,32.031,6.982,30.353,30.353,0,0,1,29.287-2.3c3.651-5.156,13.344-3.244,14.764,2.913.807-4.152,7.192-5.718,9.829-2.411s-.312,9.183-4.539,9.046a16.937,16.937,0,0,1-2.982,16.9,11.015,11.015,0,1,1-12.206,18.337,4.517,4.517,0,1,1-8.509-2.081c-3.188,2.364-7.55,2.065-11.5,1.66l-18.679-1.915c-2.973-.3-6.055-.6-8.887.355a42.145,42.145,0,0,0-5.117,2.543,21.649,21.649,0,0,1-25.641-5.569l-17,2.83c-4.992.831-10.3,1.63-14.967-.329l-4.511,1.725c-4.468,1.708-9.143,3.446-13.9,2.951s-9.574-3.979-9.867-8.753c-4.322-.485-7.218,4.077-10.493,6.939C2322.393,786.373,2309.253,783.556,2305.22,774.767Z",
  fill: "#9ab748"
});

var SvgHouse1 = function SvgHouse1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612.742,
    height: 496.705,
    viewBox: "0 0 612.742 496.705",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    transform: "translate(-2090.749 -315.835)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_308",
    "data-name": "Grupo 308"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_373",
    "data-name": "Trazado 373",
    d: "M2443.309,545.7c5.883-15.993,4.379-33.747,1.008-50.451-1.712-8.482-3.99-17.1-9.095-24.089s-13.627-12.063-22.195-10.858a64.486,64.486,0,0,0-7.7-43.847c3.417,14.443.81,30.811-9.791,41.053-12.8,12.371-32.714,12.675-50.5,11.768,16.193,9.162,23.54,31.3,16.039,48.325s-28.8,26.544-46.485,20.777c4.119,17.277-4.6,36.792-20.222,45.247s-36.728,5.088-48.942-7.806c-9.622,7.594-22.039,12.662-34.1,10.474s-22.817-13.308-21.682-25.514a49.342,49.342,0,0,1-65.748-55.41c-5.853,2.951-13.386.023-17.362-5.188s-5.062-12.071-5.146-18.626c-.026-2.01.059-4.019.2-6.024a45.346,45.346,0,0,0-10.788,26.529c-1.058,20.6,12.535,40.663,31.4,49.025-6.351,8.354-2.855,21.465,5.536,27.768s19.992,6.8,30.135,4.109a31.449,31.449,0,0,0,41.4,43.411,48.1,48.1,0,0,0,25.682,27.51c11.693-.133,23.407.181,35.127.833a47.193,47.193,0,0,0,20.615-14.922c23.882,16.6,59.444,13.546,80.141-6.891,15.225,6.744,34.755,1.8,44.942-11.369s10.057-33.317-.3-46.357C2422.524,575.346,2437.426,561.691,2443.309,545.7Z",
    fill: "#9ab748",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_319",
    "data-name": "Grupo 319"
  }, _ref5, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    "data-name": "Trazado 375",
    d: "M2401.926,437.731l117.63,98.657-18.972,256.129-17.55-.316Z",
    fill: "#f2b84b",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    "data-name": "Trazado 376",
    d: "M2663.747,529.273V552.2l-185.3-168.856-70.831,67.036L2396.867,437.1l80.95-79.052Z",
    fill: "#f2b84b",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref6, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    "data-name": "Trazado 378",
    d: "M2485.405,542.4V523.107l-90.594-82.056-86.958,87.115v11.7l86.8-82.214Z",
    fill: "#fcca7a",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1016",
    "data-name": "Rect\\xE1ngulo 1016",
    width: 177.868,
    height: 48.854,
    transform: "translate(2487.777 743.663)",
    fill: "#5f4071",
    opacity: 0.52,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_309",
    "data-name": "Grupo 309"
  }, _ref10, _ref11, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M2407.025,634.017v6.047h44.546v69.843h6.048v-75.89Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref12), _ref13), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_312",
    "data-name": "Grupo 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_311",
    "data-name": "Grupo 311"
  }, _ref14, _ref15, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M2366.116,525.684v6.047h44.546v69.843h6.047v-75.89Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref16), _ref17), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_313",
    "data-name": "Grupo 313"
  }, _ref18, _ref19, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    "data-name": "Trazado 387",
    d: "M2544.9,525.684v6.047h44.546v69.843h6.048v-75.89Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref20), _ref21), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_316",
    "data-name": "Grupo 316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315"
  }, _ref22, _ref23, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    d: "M2330.036,634.017v6.047h44.546v69.843h6.048v-75.89Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref24), _ref25), _ref26, _ref27, _ref28, _ref29, _ref30, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    d: "M2571.414,643.583a15.541,15.541,0,0,0-7.373,1.851,15.566,15.566,0,0,1,19.192,15.185v47.47h3.794V659.2A15.613,15.613,0,0,0,2571.414,643.583Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref31, _ref32, _ref33), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324"
  }, _ref34, _ref35, _ref36, _ref37, _ref38, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M2499.072,736.4a9.187,9.187,0,0,1-.874,1.7,9.93,9.93,0,0,1-9.687,4.14,10.334,10.334,0,0,1-11.1,16.135,17.983,17.983,0,0,1-30.9-1.07c-4.727,3.667-9.642,7.426-15.451,8.856s-12.8-.114-15.963-5.191c-7.824,6.082-20.783,3.608-25.816-4.929a17.343,17.343,0,0,1-29.91,1.236c-1.958,2.039-4.394,3.865-7.211,4.092s-5.936-1.729-6.093-4.551c-2.3,1.153-4.732,2.3-7.3,2.234s-5.29-1.785-5.59-4.341c-1.745,4.762-6.117,8.871-11.19,8.89s-9.854-5.326-8.163-10.107c-5.982,3.222-13.084,3.362-19.878,3.426-2.081.02-4.341-.018-5.979-1.3s-1.948-4.316-.075-5.226c-3.087,1.624-7.406-1.582-6.746-5.008a43.337,43.337,0,0,1-8.139-2.269c.356.728.717,1.454,1.039,2.192a21.3,21.3,0,0,1-.517,17.892c-1.387,2.735-3.373,5.167-4.457,8.036s-1.025,6.511,1.258,8.559,6.921.8,6.946-2.268c1.583,5.327,10.915,5.262,12.424-.087,3.483,5.794,14.178,3.954,15.525-2.671,4.033,8.788,17.173,11.606,24.455,5.244,3.275-2.862,6.171-7.424,10.493-6.939.293,4.774,5.109,8.259,9.867,8.753s9.433-1.243,13.9-2.951l4.511-1.725c4.667,1.958,9.975,1.16,14.967.329l17-2.83a21.649,21.649,0,0,0,25.641,5.569,42.082,42.082,0,0,1,5.117-2.543c2.832-.954,5.914-.66,8.887-.355l18.679,1.915c3.947.4,8.31.7,11.5-1.659a4.517,4.517,0,1,0,8.509,2.08,11.015,11.015,0,1,0,12.206-18.338,16.935,16.935,0,0,0,2.982-16.9C2497.759,744.545,2500.52,739.762,2499.072,736.4Z",
    fill: "#9ab748",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house1.1d19726b.svg";
export { ForwardRef as ReactComponent };